__turbopack_context__.v({
  "backgroundImage": "ShopSection-module-scss-module__AO-KIG__backgroundImage",
  "section": "ShopSection-module-scss-module__AO-KIG__section",
  "sectionDescription": "ShopSection-module-scss-module__AO-KIG__sectionDescription",
  "sectionHeaderContainer": "ShopSection-module-scss-module__AO-KIG__sectionHeaderContainer",
  "sectionHeaderContainerWithBackground": "ShopSection-module-scss-module__AO-KIG__sectionHeaderContainerWithBackground",
  "sectionHeaderContentWrap": "ShopSection-module-scss-module__AO-KIG__sectionHeaderContentWrap",
  "sectionTitle": "ShopSection-module-scss-module__AO-KIG__sectionTitle",
});
